import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'

interface AuthState {
    isUser: boolean
    token: string
    refreshToken: string
}
interface LoginPayload {
    isUser: boolean
    token: string
    refreshToken: string
}
export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isUser: false,
        token: '',
        refreshToken: '',
    } as AuthState,
    reducers: {
        LOGIN: (state, action: PayloadAction<LoginPayload>): void => {
            state.isUser = action.payload.isUser
            state.token = action.payload.token
            state.refreshToken = action.payload.refreshToken
        },
        LOGOUT: (state): void => {
            state.isUser = false
            state.token = ''
            state.refreshToken = ''
        },
    },
})

export const { LOGIN, LOGOUT } = authSlice.actions

export const selectAuth = (state: RootState): AuthState =>
    state.persistedReducers.auth

export default authSlice.reducer
